import React from "react";
import injectSheet from "react-jss";
import Icon from "../../assets/icons/Icon";
import { globalTheme } from "../../styles/globalTheme";
import TooltipPopup from "../Tooltip/TooltipPopup";
const Radiomark = (props) => {
  const { classes, id, informations, label } = props;
  const checked = props.checked === true || props.checked === "true";
  const i = informations && informations.find((x) => x.property === props.name);

  const info =
    i && i.info ? (
      <div
        style={{ marginLeft: "10px" }}
        data-tooltip-content={i.info}
        data-tooltip-id="top"
        data-tooltip-variant="dark"
      >
        {" "}
        <Icon fill="#335cda" width="18px" type="info" /> <TooltipPopup />
      </div>
    ) : null;

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      props.handleEventChange(e);
    }
  };

  return (
    <label className={classes.container}>
      {label} {info}
      <input
        id={id ? id : props.label + props.name}
        disabled={props.disabled === true}
        type="radio"
        data-cy={label.toLowerCase()}
        name={props.name}
        value={props.value}
        checked={checked}
        onChange={props.disabled === true ? () => {} : props.handleEventChange}
        onKeyPress={handleKeyPress}
      />
      <span className={classes.checkmark} />
    </label>
  );
};

const styles = (theme) => ({
  checkmark: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "20px",
    width: "20px",
    backgroundColor: "white",
    border: "1.5px solid #cbd2dc",
    borderRadius: "50%",
    "&:after": {
      content: '""',
      position: "absolute",
      display: "none",
    },
  },
  container: {
    paddingLeft: "28px",
    paddingTop: "3px",
    position: "relative",
    userSelect: "none",
    marginRight: "21px",
    cursor: "pointer",
    display: "flex",
    fontWeight: 400,
    "& input": {
      left: 0,
      top: 0,
      position: "absolute",
      opacity: 0,
    },
    "& input:checked ~ $checkmark": {
      border: "1.5px solid " + theme.themeColor, //"1.5px solid #335cda"
    },
    "& input:disabled ~ $checkmark": {
      border: "1.5px solid #cbd2dc",
    },
    "& input:disabled ~ $checkmark:after": {
      background: "#cbd2dc",
    },
    "& input:checked ~ $checkmark:after": {
      display: "block",
    },
    "& input:focus ~ $checkmark": {
      outline: globalTheme.outline,
      outlineOffset: "2px",
    },
    "& $checkmark:after": {
      top: "4.5px",
      left: "4.5px",
      width: "11px",
      height: "11px",
      borderRadius: "50%",
      background: theme.themeColor, // "#335cda"
    },
  },
  "@media (max-width: 1023px)": {
    container: {
      display: "block",
      marginBottom: "14px",
      marginLeft: "2px",
    },
  },
});
export default injectSheet(styles)(Radiomark);
